import { useQuery } from "@tanstack/react-query";


export function GetCompania() {
   const url = process.env.REACT_APP_URL_DIR + "compania";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["clientes"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json())
   });
   return data;
}
